import UploadPhotos from "./UploadPhotos"
import styles from "./PhotosUploadModal.module.scss"
import { connect } from "react-redux"
import { openIdentityModal, sendIdentityPhotos } from "../../store/actions"
import { useNavigate } from "react-router-dom"
import { motion, AnimatePresence } from "framer-motion"

const PhotoUploadModal = ({
  closeModal,
  onSubmit,
  handleSendPhotos,
  identityModal,
  sendIdentityPhotos,
  openIdentityModal,
}) => {
  const navigate = useNavigate()

  const handleSendPhotosFromForm = (files) => {
    const email = identityModal?.emailToValidate
    sendIdentityPhotos(files, email, navigate)
  }

  const handleCloseModal = () => {
    openIdentityModal(false)
  }

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal()
    }
  }

  const backdropVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    exit: { opacity: 0 },
  }

  const modalVariants = {
    hidden: {
      opacity: 0,
      scale: 0.9,
      y: 20,
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 30,
      },
    },
    exit: {
      opacity: 0,
      scale: 0.9,
      y: 20,
      transition: {
        duration: 0.2,
      },
    },
  }

  return (
    <AnimatePresence>
      <motion.div
        className={styles.modalOverlay}
        variants={backdropVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        onClick={handleBackdropClick}
      >
        <motion.div
          className={styles.modalContainer}
          variants={modalVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          onClick={(e) => e.stopPropagation()}
        >
          <div className={styles.modalBody}>
            {identityModal?.isOpen ? (
              <UploadPhotos closeModal={handleCloseModal} handleSendPhotos={handleSendPhotosFromForm} />
            ) : (
              <UploadPhotos onSubmit={onSubmit} closeModal={closeModal} handleSendPhotos={handleSendPhotos} />
            )}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  )
}

const mapStateToProps = (state) => {
  return {
    identityModal: state.register.identityModal,
  }
}

export default connect(mapStateToProps, { sendIdentityPhotos, openIdentityModal })(PhotoUploadModal)
